import { render } from "./HeaderLogo.vue?vue&type=template&id=370f765c&scoped=true"
import script from "./HeaderLogo.vue?vue&type=script&lang=js"
export * from "./HeaderLogo.vue?vue&type=script&lang=js"

import "./HeaderLogo.vue?vue&type=style&index=0&id=370f765c&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370f765c"]])

export default __exports__